module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/panels-wells/panels-wells.component.scss
// module id = ./src/app/shared/components/panels-wells/panels-wells.component.scss
// module chunks = main